export const handleGA4UndefinedValues = (dataLayer) =>
  dataLayer?.reduce((query, { key, value }) => {
    const paramValue = value?.definition ?? value;
    query[key] = paramValue === "undefined" ? undefined : paramValue;
    return query;
  }, {});

export const calculateListingIndex = (index, page) => {
  const ITEMS_PER_PAGE = 35;
  return (page - 1) * ITEMS_PER_PAGE + index;
};
